var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:wechat:open-platform:config"],
                  expression: "['admin:wechat:open-platform:config']",
                },
              ],
              attrs: { type: "primary" },
              on: { click: _vm.openCreate },
            },
            [_vm._v("\n      新增服务商配置\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { icon: "el-icon-refresh" }, on: { click: _vm.load } },
            [_vm._v("刷新状态")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.list, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "platformName",
              label: "配置名称",
              "min-width": "140",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "componentAppId",
              label: "第三方平台AppID",
              "min-width": "190",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "运行状态", width: "125" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.ticketReceived
                            ? "success"
                            : scope.row.status === "ERROR"
                            ? "danger"
                            : "warning",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.ticketReceived
                                ? "已收到Ticket"
                                : scope.row.status === "ERROR"
                                ? "启动失败"
                                : "等待Ticket"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "敏感参数", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.secretConfigured &&
                            scope.row.tokenConfigured &&
                            scope.row.aesKeyConfigured
                            ? "均已配置"
                            : "配置不完整"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "verifyTicketTime",
              label: "最近Ticket时间",
              "min-width": "165",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lastError",
              label: "最近错误",
              "min-width": "260",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "245", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.showUrls(scope.row)
                          },
                        },
                      },
                      [_vm._v("回调地址")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:wechat:open-platform:config"],
                            expression: "['admin:wechat:open-platform:config']",
                          },
                        ],
                        attrs: {
                          type: "text",
                          disabled: scope.row.enabled !== 1,
                          loading: _vm.startingId === scope.row.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.startPush(scope.row)
                          },
                        },
                      },
                      [_vm._v("启动Ticket推送")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:wechat:open-platform:config"],
                            expression: "['admin:wechat:open-platform:config']",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑服务商配置" : "新增服务商配置",
            visible: _vm.formVisible,
            width: "660px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.formVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "配置名称", prop: "platformName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.platformName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "platformName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.platformName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "第三方平台AppID", prop: "componentAppId" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: !!_vm.form.id,
                      placeholder: "wx开头的18位AppID",
                    },
                    model: {
                      value: _vm.form.componentAppId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "componentAppId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.componentAppId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "ComponentSecret",
                    prop: _vm.form.id ? "" : "componentSecret",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      placeholder: _vm.form.id
                        ? "留空表示不修改"
                        : "请输入ComponentSecret",
                    },
                    model: {
                      value: _vm.form.componentSecret,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "componentSecret",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.componentSecret",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "消息校验Token",
                    prop: _vm.form.id ? "" : "messageToken",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      placeholder: _vm.form.id
                        ? "留空表示不修改"
                        : "与微信开放平台配置一致",
                    },
                    model: {
                      value: _vm.form.messageToken,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "messageToken",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.messageToken",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "EncodingAESKey",
                    prop: _vm.form.id ? "" : "encodingAesKey",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      maxlength: "43",
                      placeholder: _vm.form.id
                        ? "留空表示不修改"
                        : "43位消息加解密Key",
                    },
                    model: {
                      value: _vm.form.encodingAesKey,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "encodingAesKey",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.encodingAesKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "后台公网HTTPS地址", prop: "publicBaseUrl" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "https://admin-api.example.com" },
                    model: {
                      value: _vm.form.publicBaseUrl,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "publicBaseUrl",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.publicBaseUrl",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("填写外网可访问后端接口的根地址，不要带末尾斜杠。"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "启用" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "enabled", $$v)
                      },
                      expression: "form.enabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.formVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "微信开放平台回调配置",
            visible: _vm.urlVisible,
            width: "760px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.urlVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title:
                "将以下地址填入微信开放平台；Token和EncodingAESKey必须与本系统保存值完全一致。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            { staticClass: "url-form", attrs: { "label-width": "145px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "授权事件接收URL" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        value: _vm.selected.eventCallbackUrl,
                        readonly: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append" },
                          on: {
                            click: function ($event) {
                              return _vm.copy(_vm.selected.eventCallbackUrl)
                            },
                          },
                          slot: "append",
                        },
                        [_vm._v("复制")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "消息与事件接收URL" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        value: _vm.selected.messageCallbackUrl,
                        readonly: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append" },
                          on: {
                            click: function ($event) {
                              return _vm.copy(_vm.selected.messageCallbackUrl)
                            },
                          },
                          slot: "append",
                        },
                        [_vm._v("复制")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "请保留地址中的 $APPID$，微信推送时会替换为授权小程序AppID。"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "授权回调URI" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        value: _vm.selected.authorizationCallbackUrl,
                        readonly: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append" },
                          on: {
                            click: function ($event) {
                              return _vm.copy(
                                _vm.selected.authorizationCallbackUrl
                              )
                            },
                          },
                          slot: "append",
                        },
                        [_vm._v("复制")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }